module.exports = __webpack_public_path__ + "static/img/02.dad64ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hat/02.png
// module id = Yn17
// module chunks = 0